import React from "react";
import { useEffect, useState } from "react";
import Tooltip from "react-tooltip";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import {
  BuildingOfficeIcon,
  ChevronRightIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import DashboardCard2 from "../../../components/DashboardCard2";
import { useGetOfficeCount } from "../../CarrierAgreementMgmt/OfficeSettings/hooks/useGetOfficeCount";
import { OFFICE_PERMISSIONS } from "modules/CarrierAgreementMgmt/OfficeSettings/permission";

const NewOfficeCard = () => {
  const { data: officeCount, isLoading } = useGetOfficeCount();
  const history = useHistory();
  const modulePermission =
    OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  return (
    <>
      <div
        className="flex w-full bg-VividSkyBlue lg:p-4 md:p-2 rounded-lg cursor-pointer"
        onClick={() => {
          if (userPermissions.includes(modulePermission)) {
            const urlPath = "/officesettings/officesetting";
            history.push({
              pathname: urlPath,
              state: {
                officeKey: "officeKey",
              },
            });
          }
        }}
      >
        <DashboardCard2
          text="Office"
          count={isLoading ? "..." : officeCount}
          image={
            <BuildingOfficeIcon className="text-white rounded-lg h-7 w-7 p-1" />
          }
          hasAccess={userPermissions.includes(modulePermission) ? true : false}
        />
        {userPermissions.includes(modulePermission) ? (
          ""
        ) : (
          <div className="relative">
            <Tooltip
              id="office"
              place="top"
              effect="solid"
              type="info"
              border={false}
              arrowColor="#3a3b3c"
              // borderColor="#0078d7"
              backgroundColor="#3a3b3c"
              textColor="white"
            />
            <InformationCircleIcon
              data-tip={
                "Contact your System Administrator to secure access to this module."
              }
              data-for="office"
              className="h-6 w-6 mr-2 text-white"
            />
          </div>
        )}
      </div>

      {/* ) : ( */}
      {/* <div className="flex w-full bg-tertiary lg:p-4 md:p-2 rounded-lg cursor-pointer" />
      )} */}
    </>
  );
};
export default NewOfficeCard;
